import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=89c9acc0&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&id=89c9acc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c9acc0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatePostAccountsPicker: require('/home/runner/work/postpone/postpone/frontend/components/createPost/AccountsPicker.vue').default,CreatePostAccountsMenu: require('/home/runner/work/postpone/postpone/frontend/components/createPost/AccountsMenu.vue').default,PlatformIcon: require('/home/runner/work/postpone/postpone/frontend/components/platform/Icon.vue').default,SocialAccountDropdown: require('/home/runner/work/postpone/postpone/frontend/components/social/AccountDropdown.vue').default,SocialAccountAvatar: require('/home/runner/work/postpone/postpone/frontend/components/social/AccountAvatar.vue').default,CreatePostPreviewStack: require('/home/runner/work/postpone/postpone/frontend/components/createPost/PreviewStack.vue').default})
